// @flow

type Point = [number, number]

export function geojsonTranslate (data: any, diff: Point) {
  switch (data.geometry.type) {
    case 'Polygon':
      return {
        ...data,
        geometry: {
          type: 'Polygon',
          coordinates: data.geometry.coordinates.map(groupedCoordinates => {
            return groupedCoordinates.map(coordinate => {
              return [coordinate[0] - diff[0], coordinate[1] - diff[1]]
            })
          })
        }
      }

    case 'MultiPolygon':
      return {
        ...data,
        geometry: {
          type: 'MultiPolygon',
          coordinates: data.geometry.coordinates.map(groupedCoordinates => {
            return groupedCoordinates.map(coordinate => {
              return coordinate.map(c => {
                return [c[0] - diff[0], c[1] - diff[1]]
              })
            })
          })
        }
      }

    default:
      throw new Error(`Unexpected geojson type: ${data.geometry.type}`)
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Map/helpers.js